import Navigation from "@/components/landing/Navigation";
import Footer from "@/components/landing/Footer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Download, FileText, Calendar, Building, TrendingUp, Users, BookOpen, Calculator, Megaphone } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "@/hooks/useTranslation";
import { useMemo } from "react";
const getDocumentCategories = (t: any) => [{
  id: "financial",
  label: t.investorRelations.documents.categories.financial,
  icon: BookOpen,
  documents: [{
    name: `2025 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2026",
    size: "734 KB",
    description: "Annual financial report for 2025",
    year: 2025,
    filePath: "/documents/annual-reports/2025-annual-report.pdf"
  }, {
    name: `2024 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2024",
    size: "2.8 MB",
    description: "Annual financial report for 2024",
    year: 2024,
    filePath: "/documents/annual-reports/2024-annual-report.pdf"
  }, {
    name: `2023 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2023",
    size: "2.6 MB",
    description: "Annual financial report for 2023",
    year: 2023,
    filePath: "/documents/annual-reports/2023-annual-report.pdf"
  }, {
    name: `2022 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2022",
    size: "2.4 MB",
    description: "Annual financial report for 2022",
    year: 2022,
    filePath: "/documents/annual-reports/2022-annual-report.pdf"
  }, {
    name: `2021 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2021",
    size: "2.3 MB",
    description: "Annual financial report for 2021",
    year: 2021,
    filePath: "/documents/annual-reports/2021-annual-report.pdf"
  }, {
    name: `2020 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2020",
    size: "2.2 MB",
    description: "Annual financial report for 2020",
    year: 2020,
    filePath: "/documents/annual-reports/2020-annual-report.pdf"
  }, {
    name: `2019 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2019",
    size: "2.1 MB",
    description: "Annual financial report for 2019",
    year: 2019,
    filePath: "/documents/annual-reports/2019-annual-report.pdf"
  }, {
    name: `2018 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2018",
    size: "2.05 MB",
    description: "Annual financial report for 2018",
    year: 2018,
    filePath: "/documents/annual-reports/2018-annual-report.pdf"
  }, {
    name: `2017 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2017",
    size: "2.0 MB",
    description: "Annual financial report for 2017",
    year: 2017,
    filePath: "/documents/annual-reports/2017-annual-report.pdf"
  }, {
    name: `2016 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2016",
    size: "1.9 MB",
    description: "Annual financial report for 2016",
    year: 2016,
    filePath: "/documents/annual-reports/2016-annual-report.pdf"
  }, {
    name: `2015 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2015",
    size: "1.8 MB",
    description: "Annual financial report for 2015",
    year: 2015,
    filePath: "/documents/annual-reports/2015-annual-report.pdf"
  }, {
    name: `2014 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2014",
    size: "1.7 MB",
    description: "Annual financial report for 2014",
    year: 2014,
    filePath: "/documents/annual-reports/2014-annual-report.pdf"
  }, {
    name: `2013 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2013",
    size: "1.6 MB",
    description: "Annual financial report for 2013",
    year: 2013,
    filePath: "/documents/annual-reports/2013-annual-report.pdf"
  }, {
    name: `2012 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2012",
    size: "1.5 MB",
    description: "Annual financial report for 2012",
    year: 2012,
    filePath: "/documents/annual-reports/2012-annual-report.pdf"
  }, {
    name: `2011 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2011",
    size: "1.4 MB",
    description: "Annual financial report for 2011",
    year: 2011,
    filePath: "/documents/annual-reports/2011-annual-report.pdf"
  }, {
    name: `2010 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2010",
    size: "1.35 MB",
    description: "Annual financial report for 2010",
    year: 2010,
    filePath: "/documents/annual-reports/2010-annual-report.pdf"
  }, {
    name: `2009 ${t.investorRelations.documents.names.annualReport}`,
    date: "March 2009",
    size: "1.3 MB",
    description: "Annual financial report for 2009",
    year: 2009,
    filePath: "/documents/annual-reports/2009-annual-report.pdf"
  }]
}, {
  id: "governance",
  label: t.investorRelations.documents.categories.governance,
  icon: FileText,
  documents: [{
    name: `${t.investorRelations.documents.names.firstSemester}, 2026`,
    date: "July 2026",
    size: "689 KB",
    description: "First semester financial report for 2026",
    year: 2026,
    semester: true,
    filePath: "/documents/semester-reports/2026-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2025`,
    date: "July 2025",
    size: "1.9 MB",
    description: "First semester financial report for 2025",
    year: 2025,
    semester: true,
    filePath: "/documents/semester-reports/2025-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2024`,
    date: "July 2024",
    size: "1.8 MB",
    description: "First semester financial report for 2024",
    year: 2024,
    semester: true,
    filePath: "/documents/semester-reports/2024-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2023`,
    date: "July 2023",
    size: "1.7 MB",
    description: "First semester financial report for 2023",
    year: 2023,
    semester: true,
    filePath: "/documents/semester-reports/2023-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2022`,
    date: "July 2022",
    size: "1.6 MB",
    description: "First semester financial report for 2022",
    year: 2022,
    semester: true,
    filePath: "/documents/semester-reports/2022-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2021`,
    date: "July 2021",
    size: "1.5 MB",
    description: "First semester financial report for 2021",
    year: 2021,
    semester: true,
    filePath: "/documents/semester-reports/2021-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2020`,
    date: "July 2020",
    size: "1.4 MB",
    description: "First semester financial report for 2020",
    year: 2020,
    semester: true,
    filePath: "/documents/semester-reports/2020-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2019`,
    date: "July 2019",
    size: "1.3 MB",
    description: "First semester financial report for 2019",
    year: 2019,
    semester: true,
    filePath: "/documents/semester-reports/2019-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2018`,
    date: "July 2018",
    size: "1.25 MB",
    description: "First semester financial report for 2018",
    year: 2018,
    semester: true,
    filePath: "/documents/semester-reports/2018-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2017`,
    date: "July 2017",
    size: "1.2 MB",
    description: "First semester financial report for 2017",
    year: 2017,
    semester: true,
    filePath: "/documents/semester-reports/2017-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2016`,
    date: "July 2016",
    size: "1.1 MB",
    description: "First semester financial report for 2016",
    year: 2016,
    semester: true,
    filePath: "/documents/semester-reports/2016-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2015`,
    date: "July 2015",
    size: "1.0 MB",
    description: "First semester financial report for 2015",
    year: 2015,
    semester: true,
    filePath: "/documents/semester-reports/2015-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2014`,
    date: "July 2014",
    size: "950 KB",
    description: "First semester financial report for 2014",
    year: 2014,
    semester: true,
    filePath: "/documents/semester-reports/2014-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2013`,
    date: "July 2013",
    size: "900 KB",
    description: "First semester financial report for 2013",
    year: 2013,
    semester: true,
    filePath: "/documents/semester-reports/2013-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2012`,
    date: "July 2012",
    size: "850 KB",
    description: "First semester financial report for 2012",
    year: 2012,
    semester: true,
    filePath: "/documents/semester-reports/2012-1st-semester.pdf"
  }, {
    name: `${t.investorRelations.documents.names.firstSemester}, 2011`,
    date: "July 2011",
    size: "800 KB",
    description: "First semester financial report for 2011",
    year: 2011,
    semester: true,
    filePath: "/documents/semester-reports/2011-1st-semester.pdf"
  }]
}, {
  id: "presentations",
  label: t.investorRelations.documents.categories.presentations,
  icon: Calculator,
  documents: [{
    name: `2026 ${t.investorRelations.documents.names.balanceSheetFirstSemester}`,
    date: "July 2026",
    size: "203 KB",
    description: "Balance sheet for first semester 2026",
    filePath: "/documents/balance-sheets/2026-1st-semester-balance-sheet.pdf"
  }, {
    name: `2025 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2026",
    size: "1.9 MB",
    description: "Balance sheet for 2025",
    filePath: "/documents/balance-sheets/2025-balance-sheet.pdf"
  }, {
    name: `2025 ${t.investorRelations.documents.names.balanceSheetFirstSemester}`,
    date: "July 2025",
    size: "1.9 MB",
    description: "Balance sheet for first semester 2025",
    filePath: "/documents/balance-sheets/2025-1st-semester-balance-sheet.pdf"
  }, {
    name: `2024 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2024",
    size: "1.8 MB",
    description: "Balance sheet for 2024",
    filePath: "/documents/balance-sheets/2024-balance-sheet.pdf"
  }, {
    name: `2024 ${t.investorRelations.documents.names.balanceSheetFirstSemester}`,
    date: "July 2024",
    size: "1.7 MB",
    description: "Balance sheet for first semester 2024",
    filePath: "/documents/balance-sheets/2024-1st-semester-balance-sheet.pdf"
  }, {
    name: `2023 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2023",
    size: "1.6 MB",
    description: "Balance sheet for 2023",
    filePath: "/documents/balance-sheets/2023-balance-sheet.pdf"
  }, {
    name: `2023 ${t.investorRelations.documents.names.balanceSheetFirstSemester}`,
    date: "July 2023",
    size: "1.5 MB",
    description: "Balance sheet for first semester 2023",
    filePath: "/documents/balance-sheets/2023-1st-semester-balance-sheet.pdf"
  }, {
    name: `2022 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2022",
    size: "1.4 MB",
    description: "Balance sheet for 2022",
    filePath: "/documents/balance-sheets/2022-balance-sheet.pdf"
  }, {
    name: `2022 ${t.investorRelations.documents.names.balanceSheetFirstSemester}`,
    date: "July 2022",
    size: "1.3 MB",
    description: "Balance sheet for first semester 2022",
    filePath: "/documents/balance-sheets/2022-1st-semester-balance-sheet.pdf"
  }, {
    name: `2021 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2021",
    size: "1.2 MB",
    description: "Balance sheet for 2021",
    filePath: "/documents/balance-sheets/2021-balance-sheet.pdf"
  }, {
    name: `2020 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2020",
    size: "1.1 MB",
    description: "Balance sheet for 2020",
    filePath: "/documents/balance-sheets/2020-balance-sheet.pdf"
  }, {
    name: `2019 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2019",
    size: "1.0 MB",
    description: "Balance sheet for 2019",
    filePath: "/documents/balance-sheets/2019-balance-sheet.pdf"
  }, {
    name: `2017 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2017",
    size: "950 KB",
    description: "Balance sheet for 2017",
    filePath: "/documents/balance-sheets/2017-balance-sheet.pdf"
  }, {
    name: `2016 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2016",
    size: "900 KB",
    description: "Balance sheet for 2016",
    filePath: "/documents/balance-sheets/2016-balance-sheet.pdf"
  }, {
    name: `2015 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2015",
    size: "850 KB",
    description: "Balance sheet for 2015",
    filePath: "/documents/balance-sheets/2015-balance-sheet.pdf"
  }, {
    name: `2014 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2014",
    size: "800 KB",
    description: "Balance sheet for 2014",
    filePath: "/documents/balance-sheets/2014-balance-sheet.pdf"
  }, {
    name: `2013 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2013",
    size: "750 KB",
    description: "Balance sheet for 2013",
    filePath: "/documents/balance-sheets/2013-balance-sheet.pdf"
  }, {
    name: `2012 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2012",
    size: "700 KB",
    description: "Balance sheet for 2012",
    filePath: "/documents/balance-sheets/2012-balance-sheet.pdf"
  }, {
    name: `2011 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2011",
    size: "650 KB",
    description: "Balance sheet for 2011",
    filePath: "/documents/balance-sheets/2011-balance-sheet.pdf"
  }, {
    name: `2009 ${t.investorRelations.documents.names.balanceSheet}`,
    date: "March 2009",
    size: "600 KB",
    description: "Balance sheet for 2009",
    filePath: "/documents/balance-sheets/2009-balance-sheet.pdf"
  }]
}, {
  id: "regulatory",
  label: t.investorRelations.documents.categories.regulatory,
  icon: Megaphone,
  documents: [{
    name: `${t.investorRelations.documents.names.generalMeeting} 26/06/2026`,
    date: "June 2026",
    size: "68 KB",
    description: "General Meeting from June 26, 2026",
    filePath: "/documents/announcements/gm-26-06-2026.pdf"
  }, {
    name: `${t.investorRelations.documents.names.announcement} 10/09/2025`,
    date: "September 2025",
    size: "1.3 MB",
    description: "Company announcement from September 10, 2025",
    filePath: "/documents/announcements/announcement-10-09-2025.pdf"
  }, {
    name: `${t.investorRelations.documents.names.announcement} 22/08/2025`,
    date: "August 2025",
    size: "1.2 MB",
    description: "Company announcement from August 22, 2025",
    filePath: "/documents/announcements/announcement-22-08-2025.pdf"
  }, {
    name: `${t.investorRelations.documents.names.announcement} 30/07/2025`,
    date: "July 2025",
    size: "1.1 MB",
    description: "Company announcement from July 30, 2025",
    filePath: "/documents/announcements/announcement-30-07-2025.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 28/08/2023`,
    date: "August 2023",
    size: "1.8 MB",
    description: "General Meeting from August 28, 2023",
    filePath: "/documents/announcements/gm-28-08-2023.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 16/06/2021`,
    date: "June 2021",
    size: "1.7 MB",
    description: "General Meeting from June 16, 2021",
    filePath: "/documents/announcements/gm-16-06-2021.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 19/06/2020`,
    date: "June 2020",
    size: "1.6 MB",
    description: "General Meeting from June 19, 2020",
    filePath: "/documents/announcements/gm-19-06-2020.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 23/09/2019`,
    date: "September 2019",
    size: "1.5 MB",
    description: "General Meeting from September 23, 2019",
    filePath: "/documents/announcements/gm-23-09-2019.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 10/09/2019`,
    date: "September 2019",
    size: "1.4 MB",
    description: "General Meeting from September 10, 2019",
    filePath: "/documents/announcements/gm-10-09-2019.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 02/08/2019`,
    date: "August 2019",
    size: "1.3 MB",
    description: "General Meeting from August 2, 2019",
    filePath: "/documents/announcements/gm-02-08-2019.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 31/07/2018`,
    date: "July 2018",
    size: "1.2 MB",
    description: "General Meeting from July 31, 2018",
    filePath: "/documents/announcements/gm-31-07-2018.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 30/08/2017`,
    date: "August 2017",
    size: "1.1 MB",
    description: "General Meeting from August 30, 2017",
    filePath: "/documents/announcements/gm-30-08-2017.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 29/06/2016`,
    date: "June 2016",
    size: "1.0 MB",
    description: "General Meeting from June 29, 2016",
    filePath: "/documents/announcements/gm-29-06-2016.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 30/06/2015`,
    date: "June 2015",
    size: "950 KB",
    description: "General Meeting from June 30, 2015",
    filePath: "/documents/announcements/gm-30-06-2015.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 26/06/2014`,
    date: "June 2014",
    size: "900 KB",
    description: "General Meeting from June 26, 2014",
    filePath: "/documents/announcements/gm-26-06-2014.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 2/09/2013`,
    date: "September 2013",
    size: "850 KB",
    description: "General Meeting from September 2, 2013",
    filePath: "/documents/announcements/gm-02-09-2013.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 29/04/2013`,
    date: "April 2013",
    size: "800 KB",
    description: "General Meeting from April 29, 2013",
    filePath: "/documents/announcements/gm-29-04-2013.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 11/04/2013`,
    date: "April 2013",
    size: "750 KB",
    description: "General Meeting from April 11, 2013",
    filePath: "/documents/announcements/gm-11-04-2013.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 24/06/2011`,
    date: "June 2011",
    size: "700 KB",
    description: "General Meeting from June 24, 2011",
    filePath: "/documents/announcements/gm-24-06-2011.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 6/05/2010`,
    date: "May 2010",
    size: "650 KB",
    description: "General Meeting from May 6, 2010",
    filePath: "/documents/announcements/gm-06-05-2010.pdf"
  }]
}, {
  id: "assemblies",
  label: t.investorRelations.documents.categories.assemblies,
  icon: Users,
  documents: [{
    name: `${t.investorRelations.documents.names.generalMeeting} 26/06/2026`,
    date: "June 2026",
    size: "260 KB",
    description: "General Meeting from June 26, 2026",
    filePath: "/documents/general-assemblies/gm-26-06-2026.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 24/06/2025`,
    date: "June 2025",
    size: "1.9 MB",
    description: "General Meeting from June 24, 2025",
    filePath: "/documents/general-assemblies/gm-24-06-2025.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 01/08/2024`,
    date: "August 2024",
    size: "1.8 MB",
    description: "General Meeting from August 1, 2024",
    filePath: "/documents/general-assemblies/gm-01-08-2024.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 28/08/2023`,
    date: "August 2023",
    size: "1.7 MB",
    description: "General Meeting from August 28, 2023",
    filePath: "/documents/general-assemblies/gm-28-08-2023.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 16/06/2021`,
    date: "June 2021",
    size: "1.6 MB",
    description: "General Meeting from June 16, 2021",
    filePath: "/documents/general-assemblies/gm-16-06-2021.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 19/06/2020`,
    date: "June 2020",
    size: "1.5 MB",
    description: "General Meeting from June 19, 2020",
    filePath: "/documents/general-assemblies/gm-19-06-2020.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 04/10/2019`,
    date: "October 2019",
    size: "1.4 MB",
    description: "General Meeting from October 4, 2019",
    filePath: "/documents/general-assemblies/gm-04-10-2019.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 07/9/2018`,
    date: "September 2018",
    size: "1.3 MB",
    description: "General Meeting from September 7, 2018",
    filePath: "/documents/general-assemblies/gm-07-09-2018.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 30/8/2017`,
    date: "August 2017",
    size: "1.2 MB",
    description: "General Meeting from August 30, 2017",
    filePath: "/documents/general-assemblies/gm-30-08-2017.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 29/6/2016`,
    date: "June 2016",
    size: "1.1 MB",
    description: "General Meeting from June 29, 2016",
    filePath: "/documents/general-assemblies/gm-29-06-2016.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 30/6/2015`,
    date: "June 2015",
    size: "1.0 MB",
    description: "General Meeting from June 30, 2015",
    filePath: "/documents/general-assemblies/gm-30-06-2015.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 26/6/2014`,
    date: "June 2014",
    size: "950 KB",
    description: "General Meeting from June 26, 2014",
    filePath: "/documents/general-assemblies/gm-26-06-2014.pdf"
  }, {
    name: `${t.investorRelations.documents.names.corporatePresentation} 2013`,
    date: "2013",
    size: "900 KB",
    description: "Annual corporate presentation for 2013",
    filePath: "/documents/general-assemblies/annual-corporate-presentation-2013.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 2/9/2013`,
    date: "September 2013",
    size: "850 KB",
    description: "General Meeting from September 2, 2013",
    filePath: "/documents/general-assemblies/gm-02-09-2013.pdf"
  }, {
    name: `${t.investorRelations.documents.names.generalMeeting} 29/4/2013`,
    date: "April 2013",
    size: "800 KB",
    description: "General Meeting from April 29, 2013",
    filePath: "/documents/general-assemblies/gm-29-04-2013.pdf"
  }]
}];
const InvestorRelations = () => {
  const { t, language } = useTranslation();
  
  const documentCategories = useMemo(() => getDocumentCategories(t), [t, language]);
  
  const keyMetrics = [
    {
      label: t.investorRelations.keyMetrics.revenueGrowth.label,
      value: t.investorRelations.keyMetrics.revenueGrowth.value,
      description: t.investorRelations.keyMetrics.revenueGrowth.description
    },
    {
      label: t.investorRelations.keyMetrics.marketPenetration.label,
      value: t.investorRelations.keyMetrics.marketPenetration.value,
      description: t.investorRelations.keyMetrics.marketPenetration.description
    },
    {
      label: t.investorRelations.keyMetrics.healthcarePartners.label,
      value: t.investorRelations.keyMetrics.healthcarePartners.value,
      description: t.investorRelations.keyMetrics.healthcarePartners.description
    },
    {
      label: t.investorRelations.keyMetrics.patientLives.label,
      value: t.investorRelations.keyMetrics.patientLives.value,
      description: t.investorRelations.keyMetrics.patientLives.description
    }
  ];

  return <div className="min-h-screen bg-gradient-to-br from-neutral-100 to-neutral-50 relative overflow-hidden">
      {/* Flowing background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-[60%] bg-gradient-to-bl from-secondary/15 via-secondary/8 to-transparent blur-3xl" />
      <div className="absolute top-1/4 left-0 w-1/3 h-[50%] bg-gradient-to-r from-accent-teal/12 via-accent-teal/6 to-transparent blur-2xl" />
      <div className="absolute bottom-0 right-1/4 w-1/2 h-[40%] bg-gradient-to-t from-secondary/10 via-transparent to-transparent blur-3xl" />
      
      <Navigation />

      <main className="pt-32 pb-16 relative z-10">
        <div className="container mx-auto container-padding">
          {/* Hero Section */}
          <div className="max-w-6xl mx-auto mb-16">
            <div className="text-center mb-12">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-6 py-[10px] text-accent-teal font-bold">
                {t.investorRelations.title}
              </h1>
              <p className="text-base sm:text-lg md:text-xl max-w-3xl mx-auto font-normal text-slate-900 py-[2px] px-4">{t.investorRelations.description}</p>
            </div>

            {/* Stock Exchange Releases Section - Modern card with gradient border */}
            <div className="mb-8">
              <div className="relative bg-white/90 backdrop-blur-lg rounded-2xl p-8 hover:shadow-[var(--shadow-healthcare)] transition-all duration-500 border border-secondary/20">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
                  {/* Left Content */}
                  <div className="flex-1">
                    <div className="flex items-start gap-4 mb-6">
                      <div className="w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center shadow-lg relative overflow-hidden">
                        <div className="absolute inset-0 bg-white/20 animate-pulse"></div>
                        <TrendingUp className="w-8 h-8 text-white relative z-10" />
                      </div>
                      <div>
                        <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-primary mb-2 py-0 break-words hyphens-auto" style={{ wordBreak: 'break-word' }}>{t.investorRelations.stockExchange.title}</h2>
                        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-secondary/20 to-primary/20 px-4 py-2 rounded-full border border-secondary/30">
                          <div className="w-2 h-2 bg-gradient-to-r from-secondary to-primary rounded-full animate-pulse"></div>
                          <span className="text-sm font-semibold text-primary">{t.investorRelations.stockExchange.ticker}</span>
                        </div>
                      </div>
                    </div>
                    
                    <p className="text-lg text-slate-600 leading-relaxed max-w-xl py-[2px]">
                      {t.investorRelations.stockExchange.description} <span className="font-bold text-primary bg-gradient-to-r from-primary/10 to-secondary/10 px-2 py-1 rounded">OASIS</span>.
                    </p>
                  </div>

                  {/* Right Actions */}
                  <div className="flex flex-col gap-3 lg:min-w-[200px]">
                    <Button className="button-primary group w-full" onClick={() => window.open('https://www.athexgroup.gr/en/market-data/issuers/1217', '_blank')}>
                      <Building className="w-4 h-4 mr-2" />
                      {t.investorRelations.stockExchange.issuersCorner}
                    </Button>
                    <a href="https://www.athexgroup.gr/el/market-data/instruments/stocks/VIDAVO" target="_blank" rel="noopener noreferrer" className="button-secondary-nav w-full text-center block min-h-10 flex items-center justify-center px-3 sm:px-4 py-2 text-sm sm:text-base">
                      <TrendingUp className="w-4 h-4 mr-2 flex-shrink-0" />
                      <span className="break-words hyphens-auto leading-tight" style={{ wordBreak: 'break-word' }}>
                        {t.investorRelations.stockExchange.stockInfo}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Document Sections */}
            <div className="glass-panel rounded-2xl border border-secondary/20 overflow-hidden">
              <div className="px-8 py-6 border-b border-secondary/10 bg-gradient-to-r from-secondary/5 to-accent-teal/5">
                <h2 className="text-2xl font-bold text-primary mb-0 py-[5px]">{t.investorRelations.documents.title}</h2>
              </div>
              <Tabs defaultValue="financial" className="w-full">
                <div className="px-8 py-6 border-b border-secondary/10 bg-gradient-to-r from-primary/5 to-secondary/5">
                  <TabsList className="h-auto bg-transparent p-0 flex flex-wrap gap-4">
                    {documentCategories.map(category => {
                    const Icon = category.icon;
                    return <TabsTrigger key={category.id} value={category.id} className="flex items-center gap-2 px-4 py-2 rounded-lg border border-secondary/20 bg-white/50 hover:bg-white/70 data-[state=active]:bg-gradient-to-r data-[state=active]:from-primary data-[state=active]:to-secondary data-[state=active]:text-white data-[state=active]:border-primary transition-all h-auto backdrop-blur-sm">
                        <Icon className="w-4 h-4" />
                        <span className="hidden sm:inline font-medium">{category.label}</span>
                      </TabsTrigger>;
                  })}
                  </TabsList>
                </div>

                <div className="px-8 py-6">
                  {documentCategories.map(category => <TabsContent key={category.id} value={category.id} className="mt-0">
                      <div className="space-y-4">
                        {category.documents.map((document, index) => <div key={index} className="glass-panel rounded-xl p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:justify-between hover:bg-gradient-to-r hover:from-secondary/5 hover:to-primary/5 transition-all duration-300 border border-secondary/10">
                            <div className="flex-1 min-w-0 w-full sm:w-auto">
                              <h4 className="font-semibold text-primary mb-1 break-words hyphens-auto" style={{ wordBreak: 'break-word' }}>{document.name}</h4>
                            </div>
                            <Button asChild size="sm" className="w-full sm:w-auto sm:ml-4 bg-primary hover:bg-primary/90 text-white flex-shrink-0">
                              <a
                                href={(document as any).filePath || '#'}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`${t.investorRelations.documents.download}: ${document.name}`}
                              >
                                <Download className="w-4 h-4 mr-2" />
                                {t.investorRelations.documents.download}
                              </a>
                            </Button>
                          </div>)}
                      </div>
                    </TabsContent>)}
                </div>
              </Tabs>
            </div>

            {/* Contact Section - Hexagonal design */}
            <div className="mt-16 relative">
              <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-secondary/10 transform rotate-3 rounded-3xl"></div>
              <div className="relative bg-white/95 backdrop-blur-lg rounded-3xl p-8 border border-white/30 shadow-xl transform -rotate-1 hover:rotate-0 transition-transform duration-500">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div className="relative">
                    <h2 className="text-2xl font-semibold text-primary mb-4 flex items-center gap-3">
                      <Users className="w-6 h-6" />
                      {t.investorRelations.contact.title}
                    </h2>
                    <p className="text-neutral-600 mb-6 leading-relaxed">{t.investorRelations.contact.description}</p>
                  </div>
                  <div className="flex flex-col justify-center">
                    <Button asChild className="bg-white text-primary border-2 border-primary hover:bg-primary hover:text-white transition-all duration-300 mb-4 w-full">
                      <a href="mailto:hermes@vidavo.eu" className="flex items-center justify-center gap-2">
                        <Calendar className="w-4 h-4" />
                        {t.investorRelations.contact.sendEmail}
                      </a>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>;
};
export default InvestorRelations;